import { Outlet } from 'react-router';
import IotsHeaderLogo from '../../components/IotsHeaderLogo';
import LanguageSwitcher from '../../components/LanguageSwitch';
import { useLanguage } from '../../contexts/language';

const MainLayout = () => {
  const { t } = useLanguage();

  return (
    <div className="main-container bg-iots-lightgrey">
      <header className="bg-iots-brand text-iots-brand-inverted">
        <div className="main-content grid grid-cols-[1fr_auto] items-center gap-4 py-2">
          <IotsHeaderLogo />
          <div className="flex items-center">
            <LanguageSwitcher />
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="bg-white shadow-[0px_-4px_4px_0px_rgba(0,0,0,0.25)]">
        <section className="main-content grid grid-cols-[1fr] grid-rows-[repeat(2,auto)] sm:grid-cols-[1fr_auto] sm:grid-rows-[auto] gap-2 sm:gap-4 items-center">
          <p className="text-base leading-relaxed pt-[24px] sm:pt-[40px] sm:pb-[24px]">
            {t('content.hero-disclaimer.subtitle')}
          </p>
          <img
            className="py-2 justify-self-center"
            title={t('content.government-of-ireland')}
            src="/images/ireland_standard.svg"
          />
        </section>
        <div className="h-[14px] bg-iots-gold-500"></div>
      </footer>
    </div>
  );
};

export default MainLayout;
